"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDateMask = void 0;
var react_1 = __importDefault(require("react"));
var Input_1 = require("../Input");
var moment_1 = __importDefault(require("moment"));
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var maskUtils_1 = require("../../utilities/maskUtils");
var round = function (year, to) {
    if (to === void 0) { to = 100; }
    return year - (year % to);
};
var InputDateMask = function (_a) {
    var alwaysShowMask = _a.alwaysShowMask, className = _a.className, _b = _a.dateFormat, dateFormat = _b === void 0 ? 'MM/DD/YYYY' : _b, disabled = _a.disabled, error = _a.error, _c = _a.maskChar, maskChar = _c === void 0 ? '_' : _c, maxDate = _a.maxDate, minDate = _a.minDate, onChange = _a.onChange, placeholder = _a.placeholder, shortLabel = _a.shortLabel, size = _a.size, value = _a.value, tabIndex = _a.tabIndex, inputRef = _a.inputRef, props = __rest(_a, ["alwaysShowMask", "className", "dateFormat", "disabled", "error", "maskChar", "maxDate", "minDate", "onChange", "placeholder", "shortLabel", "size", "value", "tabIndex", "inputRef"]);
    var _d = react_1.default.useState(''), maskValue = _d[0], setMask = _d[1];
    var _e = react_1.default.useState(false), expandValueAtCursor = _e[0], setExpandValueAtCursor = _e[1];
    var _f = react_1.default.useState(null), cursorPosition = _f[0], setCursorPosition = _f[1];
    var falseEmptyChange = false;
    var handleKeyDown = function (evt) {
        if (evt.key === utilities_1.keys.delete) {
            onChange(undefined);
            setMask('');
        }
        if (evt.key === utilities_1.keys.slash) {
            setExpandValueAtCursor(true);
        }
    };
    var expandMaskValue = function (mask, cursorPosition) {
        var value = mask;
        var parsedValue = parseInt(maskUtils_1.getValueAtIndex(mask, cursorPosition), 10);
        if (!parsedValue)
            return value;
        var _a = maskUtils_1.findMaskFieldBoundariesAtPosition(mask, cursorPosition), startIndex = _a[0], endIndex = _a[1];
        var desiredMaskLength = endIndex - startIndex;
        if (desiredMaskLength === 4) {
            // End early if full year already exists
            if (parsedValue.toString().length === 4)
                return value;
            /**
             * auto fills year if value is between the beginning of century
             * and 5 years ahead
             *
             * @todo: Change year calculations to use current year for all non-existant values
             * E.g. 7 -> 2027, 20 -> 2020, 181 -> 2181, assuming current year is 2021
             */
            var currentYear = new Date().getFullYear();
            var beginningOfCentury = round(currentYear, 100);
            var yearsFromBeginningOfCentury = currentYear - beginningOfCentury + 5;
            var year = parsedValue + beginningOfCentury;
            if (parsedValue > yearsFromBeginningOfCentury) {
                year -= parsedValue >= 100 ? 1000 : 100;
            }
            value = maskUtils_1.setValueAtIndex(mask, cursorPosition, year);
        }
        else {
            value = maskUtils_1.expandValueAtIndex(mask, cursorPosition);
        }
        return value;
    };
    var updateMaskValue = function (value) {
        setMask(value);
        if (isMaskValid(value)) {
            onChange(parseDate(value));
        }
        else {
            onChange(undefined);
        }
    };
    var handleBeforeMaskedValueChange = function (newState, oldState) {
        var _a, _b, _c;
        falseEmptyChange =
            !/\d/.test(newState.value) && !/\d/.test(oldState.value);
        if (((_a = newState === null || newState === void 0 ? void 0 : newState.selection) === null || _a === void 0 ? void 0 : _a.start) === ((_b = newState === null || newState === void 0 ? void 0 : newState.selection) === null || _b === void 0 ? void 0 : _b.end)) {
            setCursorPosition((_c = newState === null || newState === void 0 ? void 0 : newState.selection) === null || _c === void 0 ? void 0 : _c.start);
        }
        if (expandValueAtCursor) {
            setExpandValueAtCursor(false);
            var value_1 = expandMaskValue(newState.value, newState.selection.start);
            if (value_1 === maskValue) {
                return newState;
            }
            updateMaskValue(value_1);
            // reposition cursor
            var _d = maskUtils_1.findMaskFieldBoundariesAtPosition(newState.value, newState.selection.start), endIndex = _d[1];
            newState.selection = { start: endIndex, end: endIndex };
            newState.value = value_1;
        }
        return newState;
    };
    var handleBlur = function () {
        var _a;
        if (cursorPosition) {
            var expandedValue = (_a = expandMaskValue(maskValue, cursorPosition)) !== null && _a !== void 0 ? _a : maskValue;
            if (expandedValue !== maskValue) {
                updateMaskValue(expandMaskValue(maskValue, cursorPosition));
                setCursorPosition(null);
            }
        }
    };
    var handleChange = function (event) {
        var value = event.target.value;
        setMask(value);
        if (falseEmptyChange) {
            return;
        }
        if (isMaskValid(value)) {
            onChange(parseDate(value));
        }
        else {
            onChange(undefined);
        }
    };
    var getMaskError = function () {
        return (value === undefined && doesMaskExist() && isMaskInvalid(maskValue));
    };
    var getValueError = function () {
        return value !== undefined && !isDateInRange(value);
    };
    var formatDate = function (date) {
        return date ? moment_1.default(date).format(dateFormat) : '';
    };
    var parseDate = react_1.default.useCallback(function (date) { return moment_1.default(date, dateFormat).toDate(); }, [dateFormat]);
    var doesMaskExist = function () {
        return maskValue !== '' && maskValue !== undefined;
    };
    var isMaskInvalid = function (mask) {
        return !(mask === null || mask === void 0 ? void 0 : mask.includes(maskChar)) && !isDateStringValid(mask);
    };
    var isDateInRange = react_1.default.useCallback(function (date) {
        if (minDate && maxDate) {
            return date >= minDate && date <= maxDate;
        }
        else if (minDate) {
            return date >= minDate;
        }
        else if (maxDate) {
            return date <= maxDate;
        }
        return true;
    }, [minDate, maxDate]);
    var isDateStringValid = react_1.default.useCallback(function (date) {
        return moment_1.default(date, dateFormat).isValid() &&
            isDateInRange(parseDate(date));
    }, [dateFormat, isDateInRange, parseDate]);
    var isMaskValid = react_1.default.useCallback(function (mask) { return !(mask === null || mask === void 0 ? void 0 : mask.includes(maskChar)) && isDateStringValid(mask); }, [maskChar, isDateStringValid]);
    react_1.default.useEffect(function () {
        if (value === undefined && isMaskValid(maskValue)) {
            setMask('');
        }
    }, [value, maskValue, isMaskValid]);
    /*
     * This replaces the date format with a random number (9)
     * This gets turned back to `maskChar` a few lines below.
     * I don't know why we're doing this.
     */
    var mask = dateFormat.replace(/[MmDdYyo]/g, '9');
    var realError = error || getMaskError() || getValueError();
    var realPlaceholder = placeholder || mask.replace(/9/g, maskChar);
    var classes = classnames_1.default('InputDateMask', className, {
        'InputDateMask--error': realError,
    });
    return (react_1.default.createElement(react_input_mask_1.default, __assign({}, props, { mask: mask, disabled: disabled, maskChar: maskChar, onChange: handleChange, onKeyDown: handleKeyDown, onBlur: handleBlur, beforeMaskedValueChange: handleBeforeMaskedValueChange, alwaysShowMask: alwaysShowMask, value: formatDate(value) || maskValue }), function (props) { return (react_1.default.createElement(Input_1.Input, __assign({}, props, { inputRef: inputRef, shortLabel: shortLabel, className: classes, size: size, fluid: true, error: realError, disabled: disabled, placeholder: realPlaceholder, tabIndex: tabIndex }))); }));
};
exports.InputDateMask = InputDateMask;
//# sourceMappingURL=InputDateMask.js.map